module.exports = __webpack_public_path__ + "static/media/abbiamo14.ffb545b3.png";